import { Box, Typography, Paper } from '@mui/material';
import { useHistory } from 'react-router-dom';
import ShareItems from '../Company/ShareItems';

export default function EmptyState(props) {
  const { isFreemiumCompany } = props;
  const history = useHistory();

  return (
    <Box
      sx={{
        borderRadius: '12px',
        height: '100%',
      }}
    >
      <Paper
        elevation={1}
        sx={{
          height: '100%',
          padding: '48px 32px',
          borderRadius: '12px',
          width: '100%',
          boxShadow: 'none',
          textAlign: 'center',
          position: 'relative',
        }}
      >
        <Box
          component="img"
          src="/images/activity-empty-state.png"
          alt="Empty State"
          style={{
            width: { xxs: null, sm: '100%' },
            height: '100%',
            position: 'absolute',
            bottom: 10,
            left: 0,
            right: 0,
            margin: '0 auto',
            opacity: 0.1,
            pointerEvents: 'none',
          }}
        />
        <Typography
          sx={{
            mb: 2,
            fontWeight: '700',
            fontSize: '28px',
            lineHeight: '40px',
            color: '#232B35',
          }}
        >
          This is where activity from your advisors will appear.
        </Typography>
        {isFreemiumCompany ? (
          <Typography
            sx={{
              mb: 2,
              fontWeight: '400',
              fontSize: '16px',
              color: '#232B35',
            }}
          >
            The bigger your board, the more ideas and advocates for you.
            Business contacts and followers you invite will be able to join for
            free!
          </Typography>
        ) : (
          <Typography
            sx={{
              mb: 2,
              fontWeight: '400',
              fontSize: '12px',
              color: '#232B35',
            }}
          >
            So start inviting people to your advisory board! The bigger your
            board, the more ideas and advocates for you. Business contacts and
            followers will be able to join for free!
          </Typography>
        )}
        <Typography
          sx={{
            mb: 2,
            fontWeight: '700',
            fontSize: '20px',
            lineHeight: '40px',
            color: '#232B35',
          }}
        >
          {isFreemiumCompany
            ? 'Click below to start turning contacts into followers:'
            : 'Click below to start inviting advisors'}
        </Typography>
        <ShareItems />
        <Typography
          component="button"
          onClick={() => {
            history.push('/advisors/search');
          }}
          sx={{
            mt: 1,
            display: 'inline-block',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '14px',
            lineHeight: '18px',
            color: '#2b71f6',
            textDecoration: 'underline',
          }}
        >
          or invite executives from our network
        </Typography>
      </Paper>
    </Box>
  );
}
